import { CompositeModel } from '../complex/composite.model';
import {
    ODataTimeRecordingP40OutModel,
    TimeRecordingEntryP40Model,
    TimeRecordingEntryP40ModelFromJson,
} from './time-recording-entry-p40.model';
import { ArrayModel, JsonArrayModel, ArrayModelFromJson } from '../complex/array.model';
import { ODataObject } from '../../interfaces/odata-model.interface';

export class ConfirmationTimeRecordingP40Model extends CompositeModel {
    public timeRecordingEntries: ArrayModel<TimeRecordingEntryP40Model>;
    public deliveryType: string;
    public division: string;

    /**
     * The constructor parameters are needed so that we can construct the work code for the time recording correctly.
     * For more info on how to construct the work code, see https://evorait.atlassian.net/browse/MARS-7
     *
     * @param deliveryType
     * @param division
     */
    public constructor(deliveryType: string, division: string) {
        super('ConfirmationTimeRecordingP40Model');

        this.timeRecordingEntries = <ArrayModel<TimeRecordingEntryP40Model>>(
            this.set(new ArrayModel<TimeRecordingEntryP40Model>('WorkSet'))
        );

        this.deliveryType = deliveryType;

        this.division = division;
    }

    public sortTimeRecordingEntries(): void {
        this.timeRecordingEntries.value.sort((timeRecordingEntry1, timeRecordingEntry2) =>
            timeRecordingEntry1.startDate.value.isBefore(timeRecordingEntry2.startDate.value) ? -1 : 1,
        );
    }
}

export class ConfirmationTimeRecordingP40ModelFromJson extends ConfirmationTimeRecordingP40Model {
    public constructor(data: JsonConfirmationTimeRecordingP40Model) {
        super(data.deliveryType, data.division);

        this.timeRecordingEntries = <ArrayModel<TimeRecordingEntryP40ModelFromJson>>(
            this.set(new ArrayModelFromJson(TimeRecordingEntryP40ModelFromJson, data.timeRecordingEntries))
        );
    }
}

export interface JsonConfirmationTimeRecordingP40Model {
    timeRecordingEntries: JsonArrayModel;
    deliveryType: string;
    division: string;
}

export interface ODataConfirmationTimeRecordingP40OutModel extends ODataObject {
    WorkSet: ODataTimeRecordingP40OutModel[];
}
